import { type ReactNode, useState } from 'react';

function formatValue(value: unknown): string | null {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  return String(value);
}

export function SummaryReportTable({ rows }: { rows: Array<[string, unknown]> }) {
  const visible = rows.filter(([, value]) => formatValue(value) !== null);
  if (visible.length === 0) return null;
  return (
    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.83rem' }}>
      <tbody>
        {visible.map(([label, value], index) => (
          <tr key={label} style={{ borderBottom: '1px solid #f0f0f0', background: index % 2 === 0 ? 'white' : '#f8f9fa' }}>
            <td
              style={{
                padding: '6px 10px',
                color: '#666',
                fontWeight: 500,
                width: '38%',
                verticalAlign: 'top',
                whiteSpace: 'nowrap',
              }}
            >
              {label}
            </td>
            <td style={{ padding: '6px 10px', verticalAlign: 'top', overflowWrap: 'anywhere' }}>
              {formatValue(value)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export function SummaryReportSection({
  title,
  count,
  defaultOpen = true,
  testId,
  children,
}: {
  title: string;
  count?: number;
  defaultOpen?: boolean;
  testId: string;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div style={{ marginTop: '1rem' }}>
      <button
        type="button"
        onClick={() => setOpen((previous) => !previous)}
        aria-expanded={open}
        aria-label={`${open ? 'Collapse' : 'Expand'} node ${title}`}
        data-testid={`${testId}-toggle`}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          width: '100%',
          background: '#c3c4c5',
          border: '1px solid #e8e8e8',
          borderRadius: '4px',
          cursor: 'pointer',
          padding: '0.5rem 0.75rem',
          fontWeight: 600,
          fontSize: '0.84rem',
          color: 'var(--brand)',
          textAlign: 'left',
        }}
      >
        <span style={{ fontSize: '0.6rem' }}>{open ? '▼' : '▶'}</span>
        <span style={{ flex: 1 }}>{title}</span>
        {count !== undefined && (
          <span
            style={{
              background: count > 0 ? 'var(--brand)' : '#666',
              color: 'white',
              borderRadius: '999px',
              padding: '1px 8px',
              fontSize: '0.72rem',
              fontWeight: 700,
              minWidth: '20px',
              textAlign: 'center',
            }}
          >
            {count}
          </span>
        )}
      </button>
      {open && <div style={{ paddingTop: '0.25rem' }} data-testid={`${testId}-content`}>{children}</div>}
    </div>
  );
}
